
import dayjs from 'dayjs'
export interface disabledRange {
  startYYYY?: number
  startMM?: number
  startDD?: number
  startHH?: number
  startMinute?: number
  startSS?: number
  endYYYY?: number
  endMM?: number
  endDD?: number
  endHH?: number
  endMinute?: number
  endSS?: number
}

const forEachMapItem = (step: number, length: number, start: number, extra: { min: number, max: number}) => {
  const { min, max }= extra
  let COLUMNS: { label: string | number, value: string }[] = []
  for(let node = 0; node < length; node++) {
    let _node: string | number = node * step;
    if (min - 1 < _node && _node < max + 1) {
      if (Number(_node) < 10) {
        _node = `${0}${_node}`
      }
      COLUMNS.push({ label: _node, value: `${_node}` })
    }
    if (Number(_node) > max + 1) {
      break;
    }
  }
  return COLUMNS
}

const SET_HH = ({ disabledRange = {}, step }: {
  disabledRange?: disabledRange
  step: number,
}) => {
  const { startHH, endHH } = disabledRange
  return forEachMapItem(step || 1, 24, (startHH || 0), { min: startHH || 0, max: endHH || 23}
)
}

const SET_Minute = ({ disabledRange = {}, step, currentValue }: {
  disabledRange?: disabledRange
  step: number,
  currentValue?: number[]
}) => {
  const { startHH, startMinute, endHH, endMinute } = disabledRange
  // --- 最开始的时间
  if (currentValue?.[0] && Number(currentValue?.[0]) === startHH && Number(currentValue?.[0]) === endHH) { // 开始的时间
    return forEachMapItem(step, 60, (startMinute || 0), { min: startMinute || 0, max: endMinute || 0 })
  }
  if (currentValue?.[0] && Number(currentValue?.[0]) === startHH) { // 开始的时间
    return forEachMapItem(step, 60, (startMinute || 0), { min: startMinute || 0, max: 59 })
  }
  // -- 结束的时间
  if (Number(currentValue?.[0]) === endHH) {
    return forEachMapItem(step, 60, 0, { min: 0, max: endMinute || 0 })
  }
  // 选择之后
  if (currentValue?.[0]) {
    return forEachMapItem(step, 60, 0, { min: 0, max: 59})
  }
  // 未选择
  return forEachMapItem(step, 60, (startMinute || 0), { min: (startMinute || 0), max: 59})
}

const SET_SS = ({ disabledRange = {}, step, currentValue }: {
  disabledRange?: disabledRange
  step: number,
  currentValue?: number[]
}) => {
  const { startHH, startMinute, startSS, endHH, endMinute, endSS } = disabledRange

  if (currentValue?.[0] && Number(currentValue?.[0]) === startHH && Number(currentValue?.[1]) === startMinute && Number(currentValue?.[0]) === endHH && Number(currentValue?.[1]) === endMinute) { // 开始的时分，最开始时间为最开始的秒
    return forEachMapItem(step, 60, (startSS || 0), { min: startSS || 0, max: endSS || 0 })
  }
  if (currentValue?.[0] && Number(currentValue?.[0]) === startHH && Number(currentValue?.[1]) === startMinute) { // 开始的时分，最开始时间为最开始的秒
    return forEachMapItem(step, 60, (startSS || 0), { min: startSS || 0, max: 59 })
  }
  if (currentValue?.[0] && Number(currentValue?.[0]) === endHH && Number(currentValue?.[1]) === endMinute) { // 开始的时间
    return forEachMapItem(step, 60, 0, { min: 0, max: endSS || 0 })
  }
  if (currentValue?.[0]) {
    return forEachMapItem(step, 60, 0, { min: 0, max: 59 })
  }
  // 未选择
  return forEachMapItem(step, 60, (startSS || 0), { min: (startSS || 0), max: endSS || 0 })
}

export const SET_COLUMNS = ({
  currentValue,
  _format,
  extra
}: any) => {
  let startTimeStr = extra?.disabledTime?.start;
  let endTimeStr = extra?.disabledTime?.end;
  const hasDisabled = !!startTimeStr || !!endTimeStr
  if (hasDisabled) {
    startTimeStr = `${dayjs()?.format('YYYY-MM-DD')} ${startTimeStr}`
    endTimeStr = `${dayjs()?.format('YYYY-MM-DD')} ${endTimeStr}`
    const startDate = dayjs(startTimeStr, 'YYYY-MM-DD HH:mm:ss', true);
    const endDate = dayjs(endTimeStr, 'YYYY-MM-DD HH:mm:ss', true);
    // console.log('时:', startDate.hour());     // 7
    // console.log('分:', startDate.minute());   // 7
    // console.log('秒:', startDate.second());   // 7
    // console.log('年:', startDate.year());     // 当前年份（如2023）
    // console.log('月:', startDate.month() + 1); // 月份（注意+1，因为0表示1月）
    // console.log('日:', startDate.date());     // 当前日期
    // console.log('完整格式:', startDate.format('YYYY-MM-DD HH:mm:ss')); 
  
    const startYYYY = startDate.year()
    const startMM = startDate.month()
    const startDD = startDate.date()
    const startHH = startDate.hour()
    const startMinute = startDate.minute()
    const startSS = startDate.second()
  
    const endYYYY = endDate.year()
    const endMM = endDate.month()
    const endDD = endDate.date()
    const endHH = endDate.hour()
    const endMinute = endDate.minute()
    const endSS = endDate.second()
    const disabledRange = { startYYYY, startMM, startDD, startHH, startMinute, startSS, endYYYY, endMM, endDD, endHH, endMinute, endSS}

    const HH = SET_HH({ disabledRange, step: extra?.config?.['HH']?.defaultStep || 1 })
    const Minute = SET_Minute({ disabledRange, currentValue, step: extra?.config?.['mm']?.defaultStep || 1 })
    const SS = SET_SS({ disabledRange, currentValue, step: extra?.config?.['ss']?.defaultStep || 1 })
   
    const mapObject: {[key: string]: { label: string | number; value: string; }[]} = {
      HH,
      mm: Minute,
      ss: SS
    } 
    const _list = []
    for(let node = 0; node < _format.length; node++) {
      _list.push(mapObject?.[_format[node]] || [])
    }
    return _list
  } else {
    const HH = SET_HH({ step: extra?.config?.['HH']?.defaultStep || 1 })
    const Minute = SET_Minute({ currentValue, step: extra?.config?.['mm']?.defaultStep || 1 })
    const SS = SET_SS({ currentValue, step: extra?.config?.['ss']?.defaultStep || 1 })
    const mapObject: {[key: string]: { label: string | number; value: string; }[]} = {
      HH,
      mm: Minute,
      ss: SS
    } 
    const _list = []
    for(let node = 0; node < _format.length; node++) {
      _list.push(mapObject?.[_format[node]] || [])
    }
    return _list
  }
}